import { render, staticRenderFns } from "./ImsTraderEditModal.vue?vue&type=template&id=94a74cd2&"
import script from "./ImsTraderEditModal.vue?vue&type=script&lang=js&"
export * from "./ImsTraderEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports